import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import { ROLE_PATIENT } from "../../constants/ROLES";
import { defineRole } from "../handleAccessRoles";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchPatients = async (
  lng = "english",
  params = {}
) => {
  try {
    const {
      page,
      limit,
      type,
      id,
      q,
      patientBBMSNumber,
      hospital,
      ...otherFilters
    } = params;
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_PATIENT,
      operation: "read",
    });

    console.log("canAccess", canAccess);

    if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/patient`,
      params: {
        page: page,
        limit: limit,
        id,
        q,
        hospital,
        patientBBMSNumber,
        ...otherFilters,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);
    const responsePayload = queryRes.data;
    const responseData = Array.isArray(responsePayload)
      ? responsePayload
      : responsePayload?.data || [];
    const responseCount = Array.isArray(responsePayload)
      ? undefined
      : responsePayload?.count;
    const responseTotalRecords = Array.isArray(responsePayload)
      ? responsePayload?.length
      : responsePayload?.totalRecords;

    if (type === "dropdown") {
      return (responseData || []).map((el) => {
        return {
          ...el,
          label: `${el.patientId} - ${el.firstName} ${el.lastName} (${el.patientBBMSNumber})`,
          value: el._id,
        };
      });
    }

    return !page && !limit
      ? responseData
      : { data: responseData, count: responseCount, totalRecords: responseTotalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deletePatient = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/patient`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};

export const getPatientDashboardCounts = async (lng = "english", params = {}) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_PATIENT,
      operation: "read",
    });

    if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/patient/dashboard-counts`,
      params,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const { data } = await api(options);
    return data || {};
  } catch (error) {
    toastMessage("error", error);
  }
};
